import { Box, styled } from "@mui/material";
import { StyledComponentProps } from "../../models/global/Types";

export const StyledAgendaPage = styled(Box)(
  ({ theme }: StyledComponentProps) => ({
    width: "100%",
    h1: {
      textAlign: "center",
      paddingBlock: "1rem",
      color: theme.color.dark,
    },
  })
);
